'use strict';

const $ = require('jquery');
require('jquery-validation');

/*jslint regexp: true, maxlen: 140 */
const naPhone = /^[+]?\d[\d]*$/,
    frPhone = /^0?[6-7]\d{8}$/,
    regex = {
        phone: {
            us: /^[0-9]*$/,
            ae: /^5\d{8}$/,
            qa: /^[3567]\d{7}$/,
            bh: /^[36]\d{7}$/,
            om: /^9\d{7}$/,
            kw: /^[569]\d{7}$/,
            sa: /^5\d{8}$/,
            qt: naPhone,
            ca: naPhone,
            fr: frPhone,
            it: naPhone,
            cn: /.*/,
            gb: naPhone,
            nl: naPhone,
            be: naPhone,
            lu: naPhone,
            cz: naPhone,
            dk: naPhone,
            pt: naPhone,
            fi: naPhone,
            ie: naPhone,
            hr: naPhone,
            gr: naPhone,
            pl: naPhone,
            se: naPhone,
            no: naPhone,
            ch: naPhone,
            de: naPhone,
            at: naPhone,
            es: naPhone,
            jp: /^\d[\d-/]*$/,
            sg: naPhone,
            my: naPhone,
            hk: naPhone,
            th: naPhone,
            ph: naPhone,
            kr: /^010\d+$/
        },
        postal: {
            us: /(^\d{5}(-\d{4})?$)|(^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/,
            ca: /(^\d{5}(-\d{4})?$)|(^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/,
            fr: /^\d{5}$/,
            it: /^\d{5}$/,
            be: /^\d{4}$/,
            ch: /^\d{4}$/,
            no: /^\d{4}$/,
            jp: /^(\d){3}[\-](\d){4}$/,
            cn: /^(\d){6}$/,
            gb: /^[A-Z]{1,2}\d[0-9A-Z]? {0,1}\d[A-Z]{2}$/,
            pt: /^(\d){4}[\-](\d){3}$/
        },
        address: {
            ca: /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|[0-9]+)?\b/i
        },
        email: /^[a-zA-Z0-9-_+]{1}[a-zA-Z0-9-._+]{0,62}[a-zA-Z0-9-_+]{1}@[a-zA-Z0-9-._]{1,128}[\.]{1}[a-zA-Z]{2,60}$/,
        notCC: /^(?!(([0-9 \-]){13,19})).*$/,
        UTF8CharsOnly:
            /^(?:(?![\u0000-\u001F\u007F-\u009F\u009D\u0081\u0090\u2022\u00A1\u00A4\u00A6-\u00AF\u00B1\u00B3\u00B6\uD83C-\uDBFF\uDC00-\uDFFF])[^\t\r\f ]|[-@.： (?=\r|\n)\r?\n?]|[\uFF10-\uFF5A])*$/iu
    },
    overrideErrorClass = 'validation-error',
    invalidLocationDropdownError = '.validation-error-dropdown',
    formRowElement = '.form-row',
    errorClassOuter = 'error-msg',
    errorClass = 'error-msg-inner',
    errorAttr = 'data-cs-capture',
    areaCodeSelectClass = '.area-code-select',
    areaCodeToCountry = {
        971: 'AE',
        965: 'KW',
        966: 'SA',
        968: 'OM',
        973: 'BH',
        974: 'QA'
    },
    settings = {
        // global form validator settings
        errorElement: 'div',
        errorClass: errorClass,
        highlight: function (element) {
            $(element).closest(formRowElement).addClass(overrideErrorClass);
        },
        unhighlight: function (element) {
            $(element).closest(formRowElement).removeClass(overrideErrorClass);
        },
        errorPlacement: function (error, element) {
            // Error messages which are the result of server-side validation are rendered in a different location.
            // If there are any present, use the available tags and just swap out the text of the messages.
            if (element.closest(formRowElement).find('.' + errorClassOuter).length) {
                element
                    .closest(formRowElement)
                    .find('.' + errorClass)
                    .html(error)
                    .show();
            } else {
                element.parents(formRowElement + ':first').append($('<div/>').addClass(errorClassOuter).append(error));
            }
            // ADD unmask Error Messages on the Checkout Flow for the ContentSquare - BSDDEV-13269
            if ($('#wrapper').hasClass('pt_checkout')) {
                $(error).attr(errorAttr, '');
            }
        },
        showErrors: function () {
            this.defaultShowErrors();
        },
        onkeyup: false,
        onfocusout: function (element) {
            if (!this.checkable(element)) {
                this.element(element);
            }
            // If the input is inside a parent .validation-error-dropdown, validate it
            const $parentValidationDropdown = $(element).closest(invalidLocationDropdownError);
            if ($parentValidationDropdown.length > 0) {
                validateLocationsDropdown(null, element);
            }
            // If the .area-code-select changes, validate the .phone field
            if ($(element).is(areaCodeSelectClass)) {
                const $phoneField = $(element).closest('form').find('.phone');
                this.element($phoneField);
            }
        }
    };
/*jslint regexp: false, maxlen: 120 */

/**
 * Validates phone number based on the selected area code's country regex in some cases or default to .country.
 *
 * @param {string} value - The phone number to validate.
 * @param {HTMLElement} el - The input element with the phone number.
 * @returns {boolean} - True if valid or field is optional, false otherwise.
 */

const validatePhone = function (value, el) {
    let country = $(el).closest('form').find('.country');
    let areaCodeSelect = $(el).closest('form').find(areaCodeSelectClass);
    let areaCode = areaCodeSelect.length ? areaCodeSelect.val().replace(/\D/g, '') : ''; // Remove non numeric values. Ex."+"
    let countryCode;
    // Map area code to country code and update the .country input value
    if (areaCode && areaCodeToCountry.hasOwnProperty(areaCode)) {
        let newCountryCode = areaCodeToCountry[areaCode];

        if (country.is('select')) {
            // If .country is a select, check if the newCountryCode exists as an option
            if (country.find('option[value="' + newCountryCode + '"]').length > 0) {
                country.val(newCountryCode); // Update the select value
                countryCode = newCountryCode;
            } else {
                countryCode = country.val() ? country.val() : '';
            }
        } else if (country.is('input')) {
            // If .country is an input, update its value directly
            country.val(newCountryCode);
            countryCode = newCountryCode;
        }
    } else {
        countryCode = country.val() ? country.val() : '';
    }

    value = value || el.value;
    let rgx = regex.phone[countryCode.toLowerCase()];

    if (country.length === 0 || !countryCode || !rgx) {
        return true;
    }

    let isOptional = this.optional(el);
    let isValid = rgx && rgx.test($.trim(value));
    // Hide the .show-valid element if the validation is invalid - Newsletter
    if (!isValid && $(el).siblings('.show-valid').length > 0) {
        $(el).siblings('.show-valid').css('display', 'none');
    } else {
        $(el).siblings('.show-valid').css('display', 'inline');
    }

    return isOptional || isValid;
};

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);
$.validator.addMethod('phoneSMS', validatePhone, Resources.INVALID_PHONE);

/**
 * @function
 * @description Validates a given postal code against the country's postal regex
 * @param {String} value The postal code which will be validated
 * @param {String} el The input field
 */
const validatePostalCode = function (value, el) {
    let country = $(el).closest('fieldset').find('.country'),
        rgx,
        isOptional,
        isValid;

    value = value || el.value;

    if (country.length === 0 || country.val().length === 0 || !regex.postal[country.val().toLowerCase()]) {
        return true;
    }

    rgx = regex.postal[country.val().toLowerCase()];
    isOptional = this.optional(el);
    isValid = rgx.test($.trim(value));

    return isOptional || isValid;
};

/**
 * @function
 * @description Validates a given address against the countries address regex
 * @param {String} value The address which will be validated
 * @param {String} el The input field
 */
const validateAddress = function (value, el) {
    let country = $(el).closest('form').find('.country'),
        rgx,
        isOptional,
        isValid;

    value = value || el.value;

    if (country.length === 0 || country.val().length === 0 || !regex.address[country.val().toLowerCase()]) {
        return true;
    }

    rgx = regex.address[country.val().toLowerCase()];
    isOptional = this.optional(el);
    isValid = rgx.test($.trim(value));

    return isOptional || !isValid;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
const validateOwner = function (value, el) {
    value = value || (el || {}).value;
    const isValid = regex.notCC.test($.trim(value));
    return isValid;
};

/**
 * @function
 * @description Validates a given email
 * @param {String} value The email which will be validated
 * @param {String} el The input field
 */
const validateEmail = function (value, el) {
    let val = value || el.value;
    const isOptional = this.optional(el),
        isValid = regex.email.test($.trim(val));
    return isOptional || isValid;
};

const validateRequired = function (value, el) {
    let val = value || el.value;

    // validation fix for radio buttons
    if (el.type == 'radio') {
        return $(el).is(':visible') && $(el).parent().parent().find('.active').length > 0;
    }

    return val.match(/\S/);
};

/**
 * @function
 * @description Validates all input fields for invalid characters
 * @param {String} value The value of the input field which will be validated
 * @param {String} el The input field
 * @returns {boolean} invalid returns true if a invalid char is found
 */
const validateAgainstRegex = (value, el) => {
    const val = value || el.value;

    const result = Constants.VALIDATION_REGEXS.map(regexString => new RegExp(regexString)).every(
        regex => !regex.test(val)
    );

    return result;
};

/**
 * This function validates the address locations dropdowns input elements by checking if its parent element has the 'validation-error-dropdown' class.
 * If the parent element has it? then the function returns false and invalidate the input from submission. otherwise, it returns true.
 * @param {string} value - The value of the dropdown input element.
 * @param {HTMLElement} el - The dropdown input element to be validated.
 * @returns {boolean} - Returns false if the parent element has the 'validation-error-dropdown' class; otherwise, returns true.
 */
const validateLocationsDropdown = (value, el) => {
    const $parent = $(el).closest('.form-row-input');
    return !$parent.hasClass('validation-error-dropdown');
};

/**
 * Validates Date of Birth (DOB) selection fields within a form.
 * Checks if a field with class 'input-select' is a child of 'form-dob' for a 'validation-error' class in it's row parent ".form-row-select"
 *
 * @param {string} value - The current value of the DOB field selector to validate.
 * @param {HTMLElement} el - the DOB selector field
 * @returns {boolean} - Returns true if the field is valid or not a '.form-dob' descendant, otherwise false.
 */
const validateDOBSelections = (value, el) => {
    // Ensure that the element is a '.input-select' and is within '.form-dob'
    const $el = $(el);
    if ($el.hasClass('input-select') && $el.closest('.form-dob').length > 0) {
        const $parentRow = $el.closest('.form-row-select');
        const hasError = $parentRow.hasClass('validation-error');
        return !hasError;
    }
    // If the element is not within '.form-dob', do not validate it here
    return true;
};
$.validator.addMethod('input-select', validateDOBSelections, Resources.VALIDATE_REMOTE);

/**
 * Validates password field for both password criteria and password match errors.
 * Sets a custom error message based on the type of error.
 *
 * @param {string} value - The current value of the input element.
 * @param {HTMLElement} el - The password field
 * @returns {boolean} - Return false if has an error.
 */
const validatePassword = (value, el) => {
    const $el = $(el);
    let PASSWORD_MIN_LENGTH = Resources.PASSWORD_MIN_LENGTH; // Number
    let PASSWORD_MIN_SPECIAL_CHARS = Resources.PASSWORD_MIN_SPECIAL_CHARS; // Number
    let PASSWORD_IS_FORCE_MIXED_CASE = Resources.PASSWORD_IS_FORCE_MIXED_CASE; // Boolean
    let PASSWORD_IS_FORCE_NUMBERS = Resources.PASSWORD_IS_FORCE_NUMBERS; // Boolean

    if ($el.hasClass('input-password') && !$el.hasClass('no-criteria-eligible')) {
        const $parentRow = $el.closest('.form-row');
        const hasCriteriaError = $parentRow.hasClass('password-criteria-error');
        const hasMatchError = $parentRow.hasClass('password-match-error');

        if (hasCriteriaError) {
            $.validator.messages['input-password'] = '';

            const hintHtml = `
                <div class="password-criteria-hint">
                    <p><b>${Resources.VALIDATE_PASSWORD_CRITERIA}</b></p>
                    <ul>
                        <li style="display: ${PASSWORD_MIN_LENGTH > 0 ? 'block' : 'none'};"><p>${PASSWORD_MIN_LENGTH} ${
                Resources.VALIDATE_PW_LENGTH
            }</p></li>
                        <li style="display: ${
                            PASSWORD_MIN_SPECIAL_CHARS > 0 ? 'block' : 'none'
                        };"><p>${PASSWORD_MIN_SPECIAL_CHARS}  ${Resources.VALIDATE_PW_HAVE_SPECIAL_CHARS}</p></li>
                        <li style="display: ${PASSWORD_IS_FORCE_MIXED_CASE ? 'block' : 'none'};"><p> ${
                Resources.VALIDATE_PW_MIXED_LETTERS
            }</p></li>
                        <li style="display: ${PASSWORD_IS_FORCE_NUMBERS ? 'block' : 'none'};"><p> ${
                Resources.VALIDATE_PW_HAVE_NUMBER
            }</p></li>
                    </ul>
                </div>`;

            // Append the hint if it's not already there
            if ($parentRow.find('.password-criteria-hint').length === 0) {
                $parentRow.find('.password-show-container').after(hintHtml);
            }

            return false;
        } else if (hasMatchError) {
            $.validator.messages['input-password'] = Resources.VALIDATE_PASSWORD_MATCH;
            return false;
        }
    }

    return true;
};

$.validator.addMethod('input-password', validatePassword);

/**
 * Add custom char set validation method to jQuery validation plugin.
 * Input fields must have 'input-text' css class to be validated.
 * Validators must be configured.
 */
$.validator.addMethod('input-text', validateAgainstRegex, Resources.VALIDATE_CHAR_SET);
$.validator.addMethod('input-textarea', validateAgainstRegex, Resources.VALIDATE_CHAR_SET);

$.validator.addMethod('location-dropdown', validateLocationsDropdown, '');

/**
 * Add postal code validation method to jQuery validation plugin.
 * Text fields must have 'postal-code' css class to be validated as a postal code
 */
$.validator.addMethod('postal-code', validatePostalCode, Resources.INVALID_POSTAL_ADDRESS);

$.validator.addMethod('address', validateAddress, Resources.VALIDATE_NOPOBOX);

$.validator.addMethod('required', validateRequired, Resources.VALIDATE_REQUIRED);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

/**
 * Add email validation method to jQuery validation plugin.
 * Text fields must have 'email' css class to be validated as email
 */
$.validator.addMethod('email', validateEmail, Resources.INVALID_EMAIL);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod(
    'gift-cert-amount',
    function (value, el) {
        const isOptional = this.optional(el),
            isValid = !isNaN(value) && parseFloat(value) >= 5 && parseFloat(value) <= 5000;
        return isOptional || isValid;
    },
    Resources.GIFT_CERT_AMOUNT_INVALID
);
/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod(
    'positivenumber',
    function (value) {
        if ($.trim(value).length === 0) {
            return true;
        }
        return !isNaN(value) && Number(value) >= 0;
    },
    ''
); // '' should be replaced with error message if needed

$.validator.addMethod(
    'collection-point-input',
    function (value) {
        return /.+,.+/.test($.trim(value));
    },
    Resources.INVALID_COLLECTION_POINT
);

$.validator.addMethod(
    'hubbox-search-input',
    function () {
        return sessionStorage.hubBox_cp;
    },
    Resources.HUBBOX_POINT_NOT_SELECTED
);

$.extend($.validator.messages, {
    required: Resources.VALIDATE_REQUIRED,
    remote: Resources.VALIDATE_REMOTE,
    email: Resources.VALIDATE_EMAIL,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
    minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN)
});

const validator = {
    regex: regex,
    settings: settings,
    init: function () {
        let validatorObj;
        $('form:not(.suppress)').each((_index, item) => {
            validatorObj = $(item).validate(this.settings);
        });
        return validatorObj;
    },
    initForm: function (f) {
        $(f).validate(this.settings);
    },
    initInContainer: function ($container) {
        $container.find('form').each((_index, element) => {
            this.initForm(element);
        });
    }
};

module.exports = validator;
